import { render, staticRenderFns } from "./video-call.vue?vue&type=template&id=4158b22a&scoped=true&"
import script from "./video-call.vue?vue&type=script&lang=js&"
export * from "./video-call.vue?vue&type=script&lang=js&"
import style0 from "./video-call.vue?vue&type=style&index=0&id=4158b22a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4158b22a",
  null
  
)

component.options.__file = "video-call.vue"
export default component.exports